import { useContext, useId } from "react";
import { BaseInput } from "../ObjectEditor/BaseInput";
import { WindowViewContext } from "./WindowView";
import { UPDATE_BLOCK_LABEL, UPDATE_BLOCK_TEXT } from "./windowViewReducer";

interface WindowViewBlockTextProps {
  lineIndex: number;
  blockIndex: number;
  label?: boolean;
}

/**
 * Text renderer used inside the window view for a single editor block.
 *
 * @param props - Destructured parameter object
 * @param props.lineIndex - Zero-based index of the line containing the block.
 * @param props.blockIndex - Zero-based index of the block within the line.
 * @param props.label - When true, the input edits the block's label instead of its text.
 */
export const WindowViewBlockText = ({
  lineIndex,
  blockIndex,
  label = false,
}: WindowViewBlockTextProps) => {
  const wvc = useContext(WindowViewContext);
  const thisLine = wvc?.lines[lineIndex];
  const thisBlock = thisLine?.textBlocks[blockIndex];
  const thisId = useId();

  return !wvc || !thisBlock ? (
    <></>
  ) : (
    <BaseInput
      id={thisId}
      label={label ? "Label" : "Text"}
      value={label ? thisBlock.label : thisBlock.text}
      disabled={!wvc.editable}
      onNewValue={(ret) => {
        /* istanbul ignore else */
        if (wvc && typeof ret === "string") {
          /* istanbul ignore else */
          if (label) {
            wvc.dispatch({
              operation: UPDATE_BLOCK_LABEL,
              lineIndex,
              blockIndex,
              blockLabel: ret,
            });
          } else {
            wvc.dispatch({
              operation: UPDATE_BLOCK_TEXT,
              lineIndex,
              blockIndex,
              blockText: ret,
            });
          }
        }
      }}
    />
  );
};

WindowViewBlockText.displayName = "WindowViewBlockText";
